import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./customsoftware.css";
import CustomSlider from "./CustomSlider";
import CRMBenefits from "./CRMBenefits";
import ERPApproach from "./ERPApproach";

const Customsoftware = () => {
  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>Custom Software Development Company</title>

        <meta name="title" content="Custom Software Development Company" />
        <meta
          name="description"
          content="Let’s work together to build custom software development that not only meets your goals but also sets the foundation for long-term growth. Reach out to us now to start your transformation!"
        />

        <meta
          property="og:title"
          content="Custom Software Development Company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/custom-software-development-company"
        />
      </Helmet>

      <main className="landingMain about-us pb-1">
        <div className="primary__landing__container">
          {/* hero */}
          <div className="custom-hero-wrapper custom-mb">
            <h1 className="custom-soft-hero-title">
              Custom Software Development Company
            </h1>
            <p className="custom-soft-hero-content">
              As a trusted custom software development company, we specialize in
              creating high-performance, scalable, and secure software that
              aligns with your business goals. From startups to enterprises, we
              provide innovative software solutions to streamline processes,
              enhance productivity, and boost profitability.
            </p>
            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="mt-2 career-btn re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>

        <div className="primary__landing-content-container  ">
          {/* Key AI Software Development Services. */}
          <div className="custom-mb">
            <div className="row mx-0 custom-key-row">
              <div className="col-lg-6">
                <h5 className="custom-key-title">AI Software Development</h5>
                <p className="custom-key-content">
                  Artificial Intelligence (AI) is transforming industries by
                  automating processes, enhancing decision-making, and creating
                  smarter applications. As a leading custom software development
                  company, we offer AI software development services tailored to
                  your business needs.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="fiu-need-left-btn re-hero-btn"
                >
                  <div className="re-btn-txt">Get Free Consultation</div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
              <div className="col-lg-6">
                <h6 className="key-subtitle">
                  Key AI Software Development Services.
                </h6>
                <div className="custom-key-sub-cards">
                  <div className="custom-key-right-flex">
                    <div className="custom-key-right-img-wrap">
                      <img
                        src={require("../../../image/custom-software/key-img-one.webp")}
                        alt="Custom Software Development Company"
                      />
                    </div>
                    <span className="key-sub-cards-title">
                      AI-Powered Applications{" "}
                    </span>
                  </div>
                  <p className="key-sub-cards-content">
                    Develop intelligent applications that leverage machine
                    learning and natural language processing.
                  </p>
                </div>
                <div className="custom-key-sub-cards">
                  <div className="custom-key-right-flex">
                    <div className="custom-key-right-img-wrap">
                      <img
                        src={require("../../../image/custom-software/key-img-two.webp")}
                        alt="Custom Software Development Company"
                      />
                    </div>
                    <span className="key-sub-cards-title">
                      Predictive Analytics
                    </span>
                  </div>
                  <p className="key-sub-cards-content">
                    Use AI to gain actionable insights and predict future
                    trends.
                  </p>
                </div>
                <div className="custom-key-sub-cards">
                  <div className="custom-key-right-flex">
                    <div className="custom-key-right-img-wrap">
                      <img
                        src={require("../../../image/custom-software/key-img-three.webp")}
                        alt="Custom Software Development Company"
                      />
                    </div>
                    <span className="key-sub-cards-title">
                      Chatbots and AI agents
                    </span>
                  </div>
                  <p className="key-sub-cards-content">
                    Create AI-driven tools to enhance customer engagement and
                    support.
                  </p>
                </div>
                <div className="custom-key-sub-cards">
                  <div className="custom-key-right-flex">
                    <div className="custom-key-right-img-wrap">
                      <img
                        src={require("../../../image/custom-software/key-img-four.webp")}
                        alt="Custom Software Development Company"
                      />
                    </div>
                    <span className="key-sub-cards-title">
                      Process Automation
                    </span>
                  </div>
                  <p className="key-sub-cards-content">
                    Automate repetitive tasks to improve efficiency and reduce
                    costs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden">
          {/* Why Choose Our AI Software  */}
          <div className="primary__landing-content-container  ">
            <div className="custom-mb">
              <div className="row mx-0 custom-why-ai-row">
                <div className="col-lg-8 custom-why-left">
                  <div>
                    <h6 className="custom-why-ai-title">
                      Why Choose Our{" "}
                      <span className="custom-why-ai-span">
                        {" "}
                        AI Software Development Services?{" "}
                      </span>
                    </h6>
                    <p className="custom-why-ai-content">
                      Our team of AI experts uses cutting-edge technologies to
                      deliver innovative solutions that drive business growth.
                      From concept to deployment, we ensure that your AI
                      software aligns perfectly with your strategic objectives.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="custom-ai-btn re-hero-btn"
                    >
                      {" "}
                      <div className="re-btn-txt">Get Free Demo</div>
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 text-end pr-xl-0 p-0">
                  <div className="custom-why-ai-right">
                    <img
                      src={require("../../../image/custom-software/why-ai-right-img.webp")}
                      alt="Custom Software Development Company"
                    />
                  </div>
                </div>

                <img
                  src={require("../../../image/custom-software/b.webp")}
                  alt="Custom Software Development Company"
                  className="why-b-img"
                />
              </div>
            </div>
          </div>

          {/* nearshore software development */}
          <div className="primary__landing-content-container  ">
            <div className="custom-nearshore custom-mb">
              <h2 className="custom-nearshore-title">
                Nearshore Software Development
              </h2>
              <p className="custom-nearshore-content">
                Nearshore software development has emerged as a popular choice
                for companies seeking cost-effective solutions without
                compromising on quality. As a leading custom software
                development company, we offer nearshore development services to
                provide access to skilled professionals in nearby locations.
              </p>
              <div className="row mx-0 g-4 nearshore-row-mt">
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-card-one">
                    <h6>
                      Benefits of <br /> Nearshore Software Development
                    </h6>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="fiu-need-left-btn mt-4 re-hero-btn"
                    >
                      <div className="re-btn-txt">Get Benefits </div>
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>

                    <img
                      src={require("../../../image/custom-software/b.webp")}
                      alt="Custom Software Development Company"
                      className="nearshore-card-one-img"
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/nearshore-img-one.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Reduced Costs</h6>
                    <p>
                      Nearshore development eliminates the need for expensive
                      on-site teams while maintaining top-notch quality.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/nearshore-img-two.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Enhanced Collaboration</h6>
                    <p>
                      Working in similar time zones allows seamless
                      communication and real-time updates.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/nearshore-img-three.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Access to Talent</h6>
                    <p>
                      Leverage a diverse pool of highly skilled developers who
                      understand your regional needs.
                    </p>
                  </div>
                </div>
              </div>
              <p className="custom-nearshore-content">
                Our nearshore software development services provide the perfect
                balance of affordability and quality, enabling businesses to
                scale operations efficiently.
              </p>
            </div>
          </div>

          {/* Agile Software Development */}
          <div className="primary__landing-content-container ">
            <div className="agile-software">
              <h4 className="custom-nearshore-title">
                Agile Software Development
              </h4>
              <p className="custom-nearshore-content agile-content">
                Agility is the cornerstone of modern software development. Our
                custom software development company follows agile methodologies
                to deliver projects on time and within budget.
              </p>
            </div>
          </div>
        </div>

        {/* What is Agile Software Development? */}
        <div className="what-agile-outer">
          <div className="primary__landing-content-container ">
            <div className="row mx-0 ">
              <div className="col-lg-7">
                <div className="what-agile-left">
                  <h4 className="custom-nearshore-title what-agile-title">
                    What is Agile Software Development?
                  </h4>
                  <p className="custom-nearshore-content what-agile-content ">
                    Agile software development emphasizes collaboration,
                    flexibility, and customer satisfaction. It involves
                    iterative processes where teams work closely with clients to
                    adapt to changing requirements and deliver functional
                    software in small increments. Our agile development
                    framework ensures that your software evolves in line with
                    your business needs, keeping you ahead of the competition.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="fiu-need-left-btn mt-3 re-hero-btn"
                  >
                    <div className="re-btn-txt">Get Free Consultation</div>
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="agile-benefit-card-one">
                  <h6>Key Benefits of Agile Development.</h6>
                  <img
                    src={require("../../../image/custom-software/agile-benefit-img-one.webp")}
                    alt="Custom Software Development Company"
                    className="agile-ben-img-one"
                  />
                </div>
                <div className="agile-benefit-cards card-two">
                  <img
                    src={require("../../../image/custom-software/agile-benefit-img-two.webp")}
                    alt="Custom Software Development Company"
                  />
                  <h6>Customer-Centric Approach</h6>
                  <p>Regular updates ensure alignment with business goals.</p>
                </div>
                <div className="agile-benefit-cards card-three">
                  <img
                    src={require("../../../image/custom-software/agile-benefit-img-three.webp")}
                    alt="Custom Software Development Company"
                  />
                  <h6>Faster Time-to-Market</h6>
                  <p>
                    Incremental releases ensure quicker delivery of functional
                    features.
                  </p>
                </div>
                <div className="agile-benefit-cards card-four">
                  <img
                    src={require("../../../image/custom-software/agile-benefit-img-four.webp")}
                    alt="Custom Software Development Company"
                  />
                  <h6>Improved Quality</h6>
                  <p>
                    Continuous testing and feedback loops enhance software
                    reliability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Software Development Company */}
        <div className="custom-software-wrap">
          <div className="primary__landing-content-container ">
            <h2 className="custom-soft-title">
              Custom Software Development Company
            </h2>
            <p className="custom-soft-content">
              Custom software development is the backbone of our services. As a
              premier custom software development company, we design and build
              software tailored to your specific requirements.
            </p>
            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </span>
              </button>
            </div>

            <div className="custom-software-scroll-wrapper">
              <img
                src={require("../../../image/custom-software/scroll-img.webp")}
                alt="Custom Software Development Company"
                className="custom-software-scroll-img"
              />
              <div className="why-custom-wrap">
                <h5 className="why-custom-subtitle">Why Custom Software?</h5>
                <p className="why-custom-subcontent why-custom-mw">
                  Off-the-shelf solutions may not always fit your business
                  processes. Custom software development offers personalized
                  solutions that address your unique challenges and provide a
                  competitive edge.
                </p>

                <CustomSlider />

                <p className="why-custom-subcontent why-custom-mw-two">
                  From web applications to enterprise-grade solutions, our
                  custom software development services ensure that your business
                  remains adaptable and future-ready.
                </p>
              </div>
            </div>

            {/* why choose custom software */}
            <div className="mt-4">
              <div className="row mx-0 why-choose-custom-row">
                <div className="col-lg-8 custom-why-left">
                  <div>
                    <h6 className="custom-why-ai-title why-choose-custom-title ">
                      Why Choose Our Custom
                      <span className="custom-why-ai-span">
                        {" "}
                        Software Development Company?
                      </span>
                    </h6>
                    <p className="custom-why-ai-content why-choose-custom-content">
                      Selecting the right software development partner is
                      crucial to the success of your project. Our team of
                      skilled developers, creative designers, and strategic
                      thinkers collaborate to deliver solutions that go above
                      and beyond expectations. With extensive experience across
                      industries, we ensure the delivery of user-friendly,
                      future-proof software that empowers your business.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="primary-landing-main-btn re-hero-btn"
                    >
                      <div className="re-btn-txt">Get Free Demo</div>
                      <span className="mx-2 right-arr">
                        <i
                          className="fa-solid fa-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 text-end pr-xl-0 p-0">
                  <div className="custom-why-ai-right why-choose-custom-right">
                    <img
                      src={require("../../../image/custom-software/why-custom-right-img.webp")}
                      alt="Custom Software Development Company"
                    />
                  </div>
                </div>

                <img
                  src={require("../../../image/custom-software/b-custom.webp")}
                  alt="Custom Software Development Company"
                  className="why-b-img"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Offshore Development Service */}
        <div className="offshore">
          <div className="primary__landing-content-container ">
            <div className="row mx-0 g-4 offshore-title-row">
              <div className="col-lg-5">
                <h5 className="offshore-title">Offshore Development Service</h5>
              </div>
              <div className="col-lg-7">
                <p className="offshore-content">
                  Offshore development services are an excellent way to access
                  global talent while optimizing costs. As a top-tier custom
                  software development company, we offer comprehensive offshore
                  development solutions to cater to your unique needs.
                </p>
              </div>
            </div>

            <div className="offshore-advantage">
              <h6>Advantages Of Offshore Development</h6>
              <div className="row mx-0 offshore-advantage-row">
                <div className="col-lg-4 col-md-6">
                  <div className="offshore-advantage-card">
                    <img
                      src={require("../../../image/custom-software/off-ad-img-one.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h5>Cost Efficiency</h5>
                    <p>
                      Significantly lower operational and labor costs without
                      compromising quality.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="offshore-advantage-card">
                    <img
                      src={require("../../../image/custom-software/off-ad-img-two.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h5>Diverse Expertise</h5>
                    <p>
                      Access a global pool of skilled developers specializing in
                      various technologies.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="offshore-advantage-card">
                    <img
                      src={require("../../../image/custom-software/off-ad-img-three.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h5>24/7 Productivity</h5>
                    <p>
                      Leverage time zone differences for round-the-clock project
                      progress.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="offshore-why-choose">
              <h6>Why Choose Us for Offshore Development?</h6>
              <p>
                We ensure seamless communication, transparent processes, and a
                collaborative approach, making offshore development hassle-free.
                Our dedicated offshore teams are committed to delivering
                excellence and meeting project deadlines.
              </p>
              <div className="d-flex align-items-center justify-content-center">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="primary-landing-main-btn re-hero-btn"
                >
                  <div className="re-btn-txt">Get Free Demo</div>
                  <span className="mx-2 right-arr">
                    <i
                      className="fa-solid fa-arrow-right"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
              </div>
            </div>

            {/* CRM Development */}
            <div className="crm-development custom-mb">
              <h2 className="custom-nearshore-title">CRM Development</h2>
              <p className="custom-nearshore-content">
                Customer Relationship Management (CRM) systems are essential for
                businesses aiming to enhance customer engagement and streamline
                operations. Our custom software development company specializes
                in building CRM solutions tailored to your business
                requirements.
              </p>

              <h5 className="crm-benefit-subtitle">
                Benefits Of Custom CRM Development
              </h5>

              <CRMBenefits />
            </div>
          </div>

          {/* our crm development process */}
          <div className="crm-dev-process-outer custom-mb">
            <div className="primary__landing-content-container ">
              <div className="crm-dev-process ">
                <h6>Our CRM Development Process</h6>
                <p>
                  Our custom CRM solutions empower your sales, marketing, and
                  customer service teams, driving long-term business success.
                </p>

                <div className="row mx-0 g-lg-5 g-md-4 crm-dev-process-row">
                  <div className="col-lg-4 col-md-6 pl-lg-0">
                    <div className="crm-dev-process-card">
                      <span>01</span>
                      <h5>Needs Assessment</h5>
                      <p>
                        Identify the key functionalities your business requires.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="crm-dev-process-card">
                      <span>02</span>
                      <h5>Custom Design</h5>
                      <p>
                        Develop intuitive interfaces for seamless user
                        experiences.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="crm-dev-process-card">
                      <span>03</span>
                      <h5>Integration</h5>
                      <p>
                        Ensure seamless integration with existing systems and
                        tools.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2 crm-dev-lg-none"></div>
                  <div className="col-lg-4 col-md-6">
                    <div className="crm-dev-process-card">
                      <span>04</span>
                      <h5>Testing</h5>
                      <p>Conduct rigorous testing for flawless performance.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="crm-dev-process-card">
                      <span>05</span>
                      <h5>Deployment and Support</h5>
                      <p>
                        Provide post-deployment support to ensure optimal
                        functioning.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2 crm-dev-lg-none"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="primary__landing-content-container ">
            {/* ERP Software Development*/}
            <div className="custom-nearshore custom-mb">
              <h2 className="custom-nearshore-title">
                ERP Software Development
              </h2>
              <p className="custom-nearshore-content">
                Enterprise Resource Planning (ERP) systems integrate core
                business processes into a unified system, enabling better
                decision-making and operational efficiency. As a trusted custom
                software development company, we deliver ERP solutions designed
                to meet the complex needs of modern businesses.
              </p>
              <div className="row mx-0 g-4 nearshore-row-mt features-erp-row">
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-card-one">
                    <h6>Features of Our ERP Software</h6>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="fiu-need-left-btn mt-4 re-hero-btn"
                    >
                      <div className="re-btn-txt"> Get Benefits </div>
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>

                    <img
                      src={require("../../../image/custom-software/b.webp")}
                      alt="Custom Software Development Company"
                      className="nearshore-card-one-img"
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/erp-img-one.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Modular Architecture</h6>
                    <p>
                      Tailor each module to specific business functions like
                      finance, HR, inventory, and more.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/erp-img-two.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Real-Time Data Access</h6>
                    <p>
                      Make use of real-time insights to make better decisions.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="nearshore-cards">
                    <img
                      src={require("../../../image/custom-software/erp-img-three.webp")}
                      alt="Custom Software Development Company"
                    />
                    <h6>Scalable Solutions</h6>
                    <p>
                      Ensure your ERP system evolves as your business grows.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Our ERP Development Approach. */}
            <div className="erp-dev-approach">
              <h4>Our ERP Development Approach.</h4>
              <p>
                Our ERP solutions help businesses optimize resources, reduce
                costs, and improve overall efficiency, giving you a competitive
                edge.
              </p>

              <ERPApproach />
            </div>

            <div className="offshore-why-partner">
              <div className="row mx-0 custom-why-ai-row">
                <div className="col-lg-8 custom-why-left">
                  <div>
                    <h6 className="custom-why-ai-title">
                      Why Partner with Us?
                    </h6>
                    <p className="custom-why-ai-content mt-3">
                      We are dedicated to delivering innovative, high-quality
                      software solutions tailored to your unique business needs
                      As a leading custom software development company. Our
                      commitment to excellence, transparency, and customer
                      satisfaction sets us apart. Whether you need nearshore
                      development, agile methodologies, or enterprise-grade CRM
                      and ERP systems, we have the expertise to bring your
                      vision to life.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="custom-ai-btn re-hero-btn"
                    >
                      <div className="re-btn-txt">Get Free Demo </div>
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 text-end pr-xl-0 p-0">
                  <div className="custom-why-ai-right">
                    <img
                      src={require("../../../image/custom-software/why-partner-right-img.webp")}
                      alt="Custom Software Development Company"
                    />
                  </div>
                </div>

                <img
                  src={require("../../../image/custom-software/b.webp")}
                  alt="Custom Software Development Company"
                  className="why-b-img"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Get in touch */}
        <div className="custom-get-in-touch">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title">Get in Touch</h5>
            <p className="custom-get-content">
              Contact us today to share your project requirements, and let us
              guide you through the journey of creating innovative, scalable,
              and future-proof software. Discover how partnering with our custom
              software development company can unlock new opportunities and
              drive your business success.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-3 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How much does custom software development cost?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost varies based on the software's scope,
                          functionality, and required technologies. A detailed
                          consultation ensures a transparent estimate tailored
                          to your project needs.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          What industries benefit from custom software
                          development?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Custom software development serves various industries,
                          including healthcare, finance, retail, logistics, and
                          education. It’s ideal for businesses seeking
                          personalized solutions to improve operations.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Can custom software integrate with my existing
                          systems?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, custom software is designed to integrate with
                          your current systems, tools, and databases. Our team
                          ensures smooth integration for a unified and efficient
                          workflow.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          Will I own the rights to the software developed for my
                          business?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Absolutely. As part of our development process, you
                          retain full ownership of the custom software,
                          including its source code, ensuring complete control
                          over your solution.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Can you support and maintain my software after
                          deployment?
                        </a>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, we provide ongoing support and maintenance
                          services to ensure your software stays up-to-date,
                          secure, and aligned with your evolving business needs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Customsoftware;
